const PrivacyPolicy = () => {
  return (
    <div className="container mx-auto px-4 py-10 max-w-3xl">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>

      <p className="mb-4">
        Luxor Clothing values your privacy. We collect personal information such
        as name, email, phone number, and address only for order processing,
        communication, and customer support.
      </p>

      <p className="mb-4">
        We do not sell, trade, or share your personal data with third parties
        except payment gateways and logistics partners required to complete your
        order.
      </p>

      <p className="mb-4">
        All payment transactions are secured and processed through trusted
        payment providers. Luxor Clothing does not store your card or UPI details.
      </p>

      <p>
        By using our website, you agree to this privacy policy.
      </p>
    </div>
  );
};

export default PrivacyPolicy;